import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locales from '@/locales'
Vue.use(VueI18n)
export const i18n = new VueI18n({
    locale: 'zh-hant',
    fallbackLocale: 'zh-hant',
    messages: locales,
    silentTranslationWarn: true
})
